const _find = require('../utils/find.js');
const _findIndex = require('lodash.findindex');
const getNewCountOfDish = require('./dish-helper').getNewCountOfDish;
import { DishPropertyTypes } from '../helper/const';

const isGroupDish = exports.isGroupDish = (dish) => dish.type === 1;
const isSingleDishWithoutProps = exports.isSingleDishWithoutProps = (dish) => {
  if (isGroupDish(dish)) {
    return false;
  }

  const propTypeInfo = dish.propertyTypeList || dish.dishPropertyTypeInfos || [];
  const ingredientInfos = dish.dishIngredientInfos || [];
  return !ingredientInfos.length && (!propTypeInfo.length || (propTypeInfo.every(prop => prop.type === 4 || prop.type === 2)));
};

exports.initializeDishes = (dishesList) => {
  const dishes = JSON.parse(JSON.stringify(dishesList));

  dishes.map(dish => {
    if (isSingleDishWithoutProps(dish)) {
      dish.order = dish.num;
      dish.dishIngredientInfos.forEach(ingredient => ingredient.isChecked = true);
      dish.propertyTypeList.map(property => property.properties.forEach(option => option.isChecked = true));
      dish.dishPropertyTypeInfos = dish.propertyTypeList;
    } else if (isGroupDish(dish)) {
      dish.order = [{ count:dish.num, groups:[] }];
      dish.groups = [];
      let subDishItems = dish.subDishItems || [];
      subDishItems.map(item => {
        item.id = item.groupId;
        item.childInfos = [];
        if (item.propertyTypeList.length) {
          item.propertyTypeList.map(property => property.properties.forEach(option => option.isChecked = true));
        }
        if (item.dishIngredientInfos.length) {
          item.dishIngredientInfos.map(ingredient => ingredient.isChecked = true);
        }
        let childInfo = {
          id:item.itemId,
          name:item.name,
          unitName:item.unitName,
          marketPrice:item.marketPrice,
          saleType:item.saleType,
          isChildDish:true,
          dishIngredientInfos:item.dishIngredientInfos,
          dishPropertyTypeInfos:item.propertyTypeList,
          order:isSingleDishWithoutProps(item) ? item.num : [{
            count: item.num, // / dish.num,
            dishIngredientInfos:item.dishIngredientInfos,
            dishPropertyTypeInfos:item.propertyTypeList,
          }],
        };
        item.childInfos.push(childInfo);
        return dish.order[0].groups.push(item);
      });
    } else {
      dish.dishIngredientInfos.forEach(ingredient => ingredient.isChecked = true);
      dish.propertyTypeList.map(property => property.properties.forEach(option => option.isChecked = true));
      dish.order = [{
        count:dish.num,
        dishIngredientInfos:dish.dishIngredientInfos,
        dishPropertyTypeInfos:dish.propertyTypeList,
      }];
      dish.dishPropertyTypeInfos = dish.propertyTypeList;
    }
    return dish;
  });

  return dishes;
};

exports.convertDetailStructureToOrderedStructure = (dishes) => {
  const initDishPropertyAndIngredient = dish => {
    const { propertyTypeList, dishIngredientInfos } = dish;
    (propertyTypeList || []).forEach(property => (property.properties || []).forEach(option => option.isChecked = true));
    (dishIngredientInfos || []).forEach(ingredient => ingredient.isChecked = true);
    return { dishPropertyTypeInfos: propertyTypeList || [], dishIngredientInfos: dishIngredientInfos || [] };
  };

  dishes.forEach(dish => {
    if (isSingleDishWithoutProps(dish)) {
      Object.assign(dish, { order: dish.num, dishPropertyTypeInfos: dish.propertyTypeList });
    } else if (isGroupDish(dish)) {
      const order = [{ count:dish.num, groups:[] }];
      const subDishItems = dish.subDishItems || [];

      subDishItems.forEach(group => {
        const _group = { id: group.groupId, childInfos: [] };
        (group.subDishVO || []).forEach(item => {
          const { dishIngredientInfos, dishPropertyTypeInfos } = initDishPropertyAndIngredient(item);
          const childInfo = {
            id:item.itemId,
            name:item.name,
            saleType: item.saleType,
            unitName:item.unitName,
            marketPrice:item.marketPrice,
            isChildDish:true,
            dishIngredientInfos,
            dishPropertyTypeInfos,
            order:isSingleDishWithoutProps(item) ? item.num : [{
              count: item.num,
              dishPropertyTypeInfos,
              dishIngredientInfos,
            }],
          };
          _group.childInfos.push(childInfo);
        });
        order[0].groups.push(_group);
      });
      Object.assign(dish, { order, groups: [] });
    } else {
      const { dishIngredientInfos, dishPropertyTypeInfos } = initDishPropertyAndIngredient(dish);
      Object.assign(dish, { dishPropertyTypeInfos, order: [{
        count:dish.num,
        dishIngredientInfos,
        dishPropertyTypeInfos,
      }] });
    }
  });
  return dishes;
};

/**
 * 按手录菜品备注合并单菜到order, 并动态创建dishPropertyTypeInfos property type=3(备注) array
 * @param {Array} dishes
 */
function combineSingleDishWithoutPropsToOrderByMemo(dishes) {
  const combinedRet = dishes.reduce((acc, dish) => {
    const { id, marketPrice, dishPropertyTypeInfos = [], dishIngredientInfos=[], itemId, tag } = dish;
    const key = `${id}-${marketPrice}-${itemId || tag}`;
    const { length: propertyLength } = dishPropertyTypeInfos;

    if (dishIngredientInfos.length === propertyLength && propertyLength === 0) {
      const singleKey = `${key}-single`;
      acc[singleKey] = (acc[singleKey] || []).concat(dish);
    } else {
      acc[key] = [dish];
    }

    return acc;
  }, {});

  return Object.keys(combinedRet).reduce((acc, key) => {
    const list = combinedRet[key];
    if (list.length === 1 || list.every(item => !item.memo)) {
      return acc.concat(list);
    }

    const [first] = list;

    return acc.concat({
      ...first,
      dishIngredientInfos: [{}],
      order: list.map(item => {
        const { order, memo } = item;
        const dishPropertyTypeInfos = [];

        if (memo) {
          dishPropertyTypeInfos.push({
            type: DishPropertyTypes.REMARK,
            name: '备注',
            properties: [{ id: 0, name: memo, isChecked: true }],
          });
        }

        return {
          count: order,
          dishPropertyTypeInfos,
          dishIngredientInfos: [],
        };
      }),
    });
  }, []);
}

exports.reconstructDishes = (realDishes, isDepart) => {
  const copyedDishes = JSON.parse(JSON.stringify(realDishes));
  const dishes = combineSingleDishWithoutPropsToOrderByMemo(copyedDishes);

  for (let i in dishes) {
    let withSameIdDishes;

    if (isDepart) {
      dishes[i].isDepartRepeted = true;
      withSameIdDishes = dishes.filter(dish => !dish.isDepartRepeted).filter(dish => {
        if (dish.id === dishes[i].id && dish.itemId === dishes[i].itemId) {
          return dish;
        }
        dish.isDelete = false;
        return false;
      });
    } else {
      dishes[i].isRepeted = true;
      withSameIdDishes = dishes.filter(dish => !dish.isRepeted)
        .filter(dish => dish.id === dishes[i].id && dish.marketPrice === dishes[i].marketPrice);
    }

    if (withSameIdDishes && withSameIdDishes.length) {
      for (let j = 0; j < withSameIdDishes.length; j++) {
        withSameIdDishes.forEach(dish => { dish.isRepeted = true; dish.isDelete = true; });
        if (dishes[i].order instanceof Array && withSameIdDishes[j].order instanceof Array) {
          dishes[i].order.push(withSameIdDishes[j].order[0]);
        } else {
          const order = withSameIdDishes[j].order;
          if (Array.isArray(dishes[i].order) && dishes[i].order.length) {
            // dish[i].order  是数组  那么withSameIdDishes[j].order 就肯定不是数组了
            const count = withSameIdDishes[j].order;
            withSameIdDishes[j].order = [{
              count,
              dishIngredientInfos:[],
              dishPropertyTypeInfos:[],
            }];
            dishes[i].order.push(withSameIdDishes[j].order[0]);
          } else if (Array.isArray(order) && order.length) {
            // 应该被删除的菜品是复杂菜品  将同id菜品也变为复杂菜品
            const count = dishes[i].order;
            dishes[i].dishIngredientInfos = withSameIdDishes[j].dishIngredientInfos;
            dishes[i].dishPropertyTypeInfos = withSameIdDishes[j].dishPropertyTypeInfos;
            dishes[i].order = [{
              count,
              dishIngredientInfos:[],
              dishPropertyTypeInfos:[],
            }];
            dishes[i].order.push(withSameIdDishes[j].order[0]);
          } else {
            // 两者皆不是复杂菜品
            dishes[i].order += order;
          }
        }
      }
    }
  }

  return dishes.filter(dish => !dish.isDelete);
};

exports.recombineDishData = (dishes) => {
  const dishTypeList = JSON.parse(sessionStorage.getItem('dishTypeList'));
  let finalDishesList = [];
  dishes.map(dish => {
    const dishesList = dish.dishesList;
    dishesList.map(dishData => {
      const result = _find(dishTypeList, dishType => dishType.id === dishData.dishTypeId);
      let newDishObject = {
        dishTypeInfo:result,
        dishes:[dishData],
        userInfo:dish.userInfo,
      };
      const isRepeat = _find(finalDishesList, dishProp => dishProp.dishTypeInfo && dishProp.dishTypeInfo.id === result.id);
      if (isRepeat) {
        // 表示有重复的中类
        isRepeat.dishes.push(dishData);
      } else {
        finalDishesList.push(newDishObject);
      }
      return true;
    });
    return true;
  });
  return finalDishesList;
};

exports.updateSyncShoppingCart = (state, payload) => {
  const { userInfo, increment, orderDishes } = payload;
  const [orderDish] = orderDishes;
  const { userOrderedDishList } = state;
  const userOrderIndex = _findIndex(userOrderedDishList, item => item.userInfo.userId === userInfo.userId);

  // 新用户加入
  if (userOrderIndex === -1 && increment !== -1) {
    return state.update('userOrderedDishList', items => {
      const orderDishList = [orderDish];
      return (items || []).concat([{ userInfo, dishList: orderDishList }]);
    });
  }

  const dishList = userOrderedDishList[userOrderIndex].dishList || [];
  const dishIndex = _findIndex(dishList, item => item.id === orderDish.id);
  const oldDish = dishList[dishIndex];
  const dishListChain = ['userOrderedDishList', userOrderIndex, 'dishList'];

  // 单菜
  if (isSingleDishWithoutProps(orderDish)) {
    if (dishIndex === -1) {
      return increment <= 0 ? state : state.updateIn(dishListChain, list => {
        Object.assign(orderDish, { order: getNewCountOfDish(orderDish, 0) });
        return list.concat([orderDish]);
      });
    }

    const newState = state.updateIn(dishListChain.concat([dishIndex]), dish => dish.update('order', order => (order || 0) + increment));
    return newState.updateIn(dishListChain, list => list.flatMap(item => {
      const order = item.order || 0;
      return order < (item.dishIncreaseUnit || 1) ? [] : item;
    }));
  }

  if (!oldDish) {
    return increment <= 0 ? state : state.updateIn(dishListChain, list => {
      Object.assign(orderDish.order, { count: increment });
      return list.concat([orderDish]);
    });
  }

  let orderIndex = -1;
  if (isGroupDish(orderDish)) {
    orderIndex = _findIndex(oldDish.order || [], { groups: orderDish.order[0].groups });
  } else {
    orderIndex = _findIndex(oldDish.order || [],
      {
        dishIngredientInfos: orderDish.order[0].dishIngredientInfos,
        dishPropertyTypeInfos: orderDish.order[0].dishPropertyTypeInfos,
      }
    );
  }

  if (orderIndex === -1 && increment > 0) {
    return state.updateIn(dishListChain.concat([dishIndex, 'order']), order => {
      if (order) {
        return order.concat(orderDish.order);
      }
      return orderDish.order;
    });
  }

  let newCount = 0;
  let newState = state.updateIn(dishListChain.concat([dishIndex, 'order', orderIndex, 'count']), count => {
    newCount = count + orderDish.order[0].count;
    if (newCount < (orderDish.dishIncreaseUnit || 1)) {
      newCount = 0;
    }
    return newCount;
  });

  if (newCount === 0) {
    newState = newState.updateIn(dishListChain.concat([dishIndex, 'order']), list => list.flatMap((item, index) => {
      if (index === orderIndex) {
        return [];
      }
      return item;
    }));

    newState = newState.updateIn(dishListChain, list => list.flatMap((item, index) => {
      if (item.order && item.order.length === 0) {
        return [];
      }
      return item;
    }));
  }
  return newState;
};



// WEBPACK FOOTER //
// ./src/helper/order-dinner-helper.js